module.exports = vendor.React;


//////////////////
// WEBPACK FOOTER
// external "vendor.React"
// module id = 0
// module chunks = 11